import { del, get, set } from "idb-keyval";
import { create } from "zustand";

export type OfflineMutationType = "order.create" | "order.status" | "payment.create";

export type OfflineMutation = {
  id: string;
  type: OfflineMutationType;
  payload: unknown;
  createdAt: string;
  attempts: number;
  lastError?: string;
};

const QUEUE_KEY = "tailorbook:offline-queue";

type OfflineQueueState = {
  queue: OfflineMutation[];
  hydrated: boolean;
  enqueue: (mutation: OfflineMutation) => Promise<void>;
  remove: (id: string) => Promise<void>;
  markFailed: (id: string, error: string) => Promise<void>;
  hydrate: () => Promise<void>;
  clear: () => Promise<void>;
};

export const useOfflineQueue = create<OfflineQueueState>((setState, getState) => ({
  queue: [],
  hydrated: false,
  enqueue: async (mutation) => {
    const queue = [...getState().queue, mutation];
    await set(QUEUE_KEY, queue);
    setState({ queue });
  },
  remove: async (id) => {
    const queue = getState().queue.filter((mutation) => mutation.id !== id);
    await set(QUEUE_KEY, queue);
    setState({ queue });
  },
  markFailed: async (id, error) => {
    const queue = getState().queue.map((mutation) =>
      mutation.id === id
        ? { ...mutation, attempts: mutation.attempts + 1, lastError: error }
        : mutation
    );
    await set(QUEUE_KEY, queue);
    setState({ queue });
  },
  hydrate: async () => {
    const queue = (await get<OfflineMutation[]>(QUEUE_KEY)) ?? [];
    setState({ queue, hydrated: true });
  },
  clear: async () => {
    await del(QUEUE_KEY);
    setState({ queue: [] });
  }
}));
